import * as React from 'react';

import Skeleton from 'react-loading-skeleton';

import {
  ContentWrapper,
  SkeletonLeftContentWrapper,
  SkeletonRightContentWrapper,
  Wrapper,
} from './reward-tier.styled';

export const RewardTierSkeleton: React.FC = ({ ...props }) => {
  return (
    <Wrapper {...props}>
      <Skeleton width={'40%'} />
      <ContentWrapper>
        <SkeletonLeftContentWrapper>
          <Skeleton count={2} width={'60%'} />
        </SkeletonLeftContentWrapper>
        <SkeletonRightContentWrapper>
          <Skeleton width={'30%'} />
        </SkeletonRightContentWrapper>
      </ContentWrapper>
      <Skeleton width={'40%'} />
    </Wrapper>
  );
};
